import {createSelector} from 'reselect';

import {KlarnaPropsType} from 'desktop/pages/checkout/contexts/klarnaProvider/klarnaProvider';
import {getCloudinaryURL} from 'libs/cloudinary/cloudinary';
import {getProductURL} from 'libs/productUrl/productUrl';

import {getOrderReviewItems} from '../orderReviewItems/orderReviewItems';
import {
    getOrderReviewTotals,
    getTotalsShippingProtection,
} from '../orderReviewTotals/orderReviewTotals';

/**
 * Format totals for Klarna payments
 */
export const getTotalsForKlarna = createSelector(
    getOrderReviewTotals,
    getOrderReviewItems,
    getTotalsShippingProtection,
    (
        {items, shipping, totalFinalPrice, totalTax},
        products,
        shippingProtection,
    ): Omit<KlarnaPropsType, 'shippingAddress' | 'onAuthorizeCallback' | 'billingAddress'> => {
        const totalsForKlarna = {
            amount: totalFinalPrice,
            orderLines: [
                {
                    name: shipping.title,
                    quantity: 1,
                    taxRate: shipping.shippingTaxRate,
                    totalDiscountAmount: shipping.discount,
                    totalTaxAmount: shipping.shippingTax,
                    type: 'shipping',
                    unitPrice: shipping.priceInclTax,
                },
                ...items.map(item => {
                    const {image = '', urlPath = ''} =
                        products.find(({id}) => id === item.id)?.product || {};
                    return {
                        imageUrl: getCloudinaryURL(image),
                        name: item.name,
                        productUrl: getProductURL(urlPath),
                        quantity: item.qty,
                        taxRate: item.taxRate,
                        totalDiscountAmount: item.totalDiscountAmount,
                        totalTaxAmount: item.tax,
                        type: item.virtual ? 'digital' : 'physical',
                        unitPrice: item.priceInclTax,
                    };
                }),
            ],
            orderTaxAmount: totalTax,
        };

        if (shippingProtection && shippingProtection.price > 0) {
            totalsForKlarna.orderLines.push({
                name: 'Shipping Protection',
                quantity: 1,
                taxRate: shipping.shippingProtectionTaxRate,
                totalDiscountAmount: shipping.discount,
                totalTaxAmount: shipping.shippingProtectionTax,
                type: 'shipping',
                unitPrice: Number(
                    (shippingProtection.price + shipping.shippingProtectionTax).toFixed(2),
                ),
            });
        }

        return totalsForKlarna;
    },
);
